const keyLocalStorage = {
  Theme: 'theme - page',
  tokenUId: 'Token - uidAdmin',
}

export default keyLocalStorage
